import { Box, CircularProgress, TableCell, TableRow } from "@mui/material";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashBoradCard from "./common-components/CustomCard";
import CustomTable from "./common-components/CustomTable";
import TitleBar from "./common-components/TitleBar";
import {
  ComplianceTitle,
  ComplianceWrapper,
  HeaderSection,
} from "./style/homeStyle";
import { CompanyIcon, EinIcon, ITInIcon } from "../assets/Icon/dashboredIcon";
import { getComplicance, getDashboradData } from "../stores/incorporation";
import { useAppDispatch } from "../stores/store";
import { useSelector } from "react-redux";
import ListLoadingNew from "./common-components/ListLoadingNew";
import CommonPagination from "./common-components/CommonPagination";
import { formatDate } from "../utils/functions";
import ComplianceCalender from "./ComplianceCalender";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { data } = useSelector((store: any) => store.incorporation);
  const [complianceData, setComplicanceData] = useState<any>(null);
  const [tabValue, setTabValue] = useState(false);
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [loading, setLoading] = useState(true);

  const itin = data?.itin_application;
  const einApp = data?.ein_application;
  const companyApp = data?.company_formation;
  const [fullName, setFullName] = useState<string>("John D");
  const [showIncorporationSubmenu, setShowIncorporationSubmenu] =
    useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [limit] = useState(10);

  useEffect(() => {
    getData();
  }, [pageNo]);
  useEffect(() => {
    const firstName = localStorage.getItem("firstName") || "John";
    const lastName = localStorage.getItem("lastName") || "D";
    setFullName(`${firstName} ${lastName}`);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  const getData = async () => {
    try {
      setIsLoadingList(true);
      const result = await dispatch<any>(getDashboradData({}));
      setShowIncorporationSubmenu(result?.payload?.data?.llc_bought);
      const resCompliance = await dispatch<any>(
        getComplicance({ offset: pageNo, limit })
      ).then((res: any) => {
        setComplicanceData(res?.payload?.data);
        setTotalRecords(res?.payload?.total_records);
      });
      if (result?.payload?.status === 1) {
        const res = result?.payload?.data;
      }
    } catch (error) {
    } finally {
      setIsLoadingList(false);
    }
  };
  if (loading) {
    return <ListLoadingNew />;
  }
  const companyStatus: Record<number, string> = {
    0: "Pending",
    1: "Under Review",
    2: "Submitted",
    3: "Completed",
    4: "Completed",
    5: "Completed",
    6: "Completed",
    7: "Completed",
  };
  const einAppStatus: Record<number, string> = {
    0: "Pending",
    1: "Pending",
    2: "Pending",
    3: "Pending",
    4: "Ready For Signature",
    5: "Under Review",
    6: "Submitted",
    7: "Completed",
  };
  const itinStatus: Record<number, string> = {
    0: "Pending",
    1: "Ready For Signature",
    2: "Under Review",
    3: "Submitted",
    4: "Completed",
  };

  const handlePageChange = (newPage: number) => {
    setPageNo(newPage);
  };

  return (
    <Box>
      <TitleBar
        title={" Welcome,"}
        title1={fullName}
        description={"Start managing Intech Technology"}
      ></TitleBar>

      <Box
        sx={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gap: 2,
          marginBottom: 2,
          marginTop: 4,
          // overflowX: "hidden",
        }}
      >
        <DashBoradCard
          icon={<CompanyIcon />}
          title="Company Formation"
          btnTitle={companyStatus[companyApp] || "Pending"}
          handleView={() => {
            localStorage.setItem("selectedCard", "company");
            navigate("/incorporation");
          }}
          handleClick={() => {
            localStorage.setItem("selectedCard", "company");
            companyApp === 0
              ? navigate("/incorporation")
              : navigate("/incorporation");
          }}
        />
        {showIncorporationSubmenu && (
          <DashBoradCard
            icon={<EinIcon />}
            title="EIN Application"
            btnTitle={
              einAppStatus[einApp as keyof typeof einAppStatus] || "Pending"
            }
            handleClick={() => {
              localStorage.setItem("selectedCard", "ein");
              navigate("/incorporation");
            }}
            handleView={() => {
              localStorage.setItem("selectedCard", "ein");
              navigate("/incorporation");
            }}
          />
        )}
        <DashBoradCard
          icon={<ITInIcon />}
          title="ITIN Application"
          btnTitle={itinStatus[itin] || "Pending"}
          handleClick={() => {
            navigate("/itin");
          }}
          handleView={() => navigate("/itin")}
        />
      </Box>

      {/* --------------------------------- Home Compilane Section ----------------------------------------*/}
      {complianceData?.length > 0 && (
        <ComplianceWrapper>
          <HeaderSection
            style={{
              display: "flex",
              justifyContent: "justify-between",
            }}
          >
            <ComplianceTitle>Compliance</ComplianceTitle>
            <div
              style={{
                background: "#eeeeeeff",
                padding: 5,
                display: "flex",
                borderRadius: "7px",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 20,
              }}
            >
              <button
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "4px",
                  marginRight: "15px",
                  border: "none",
                  background: tabValue === false ? "#2977cc" : "transparent",
                  color: tabValue === false ? "#fff" : "#797878ff",
                  borderRadius: "7px",
                  cursor: "pointer",
                }}
                onClick={() => setTabValue(false)}
              >
                <TableRowsOutlinedIcon fontSize="medium" />
              </button>
              <button
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "4px",
                  border: "none",
                  background: tabValue ? "#2977cc" : "transparent",
                  color: tabValue ? "#fff" : "#797878ff",
                  borderRadius: "7px",
                  cursor: "pointer",
                }}
                onClick={() => setTabValue(true)}
              >
                <CalendarMonthOutlinedIcon fontSize="medium" />
              </button>
            </div>
          </HeaderSection>
          {!tabValue ? (
            <CustomTable
              headings={[
                "SR NO.",
                "Order Type",
                "Company",
                "State",
                "Filing date",
                "Due date (Renew)",
              ]}
            >
              {isLoadingList ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : (
                complianceData?.map((item: any, idx: number) => {
                  return (
                    <TableRow>
                      <TableCell
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                        }}
                      >
                        {(pageNo - 1) * limit + idx + 1}
                      </TableCell>
                      <TableCell
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                        }}
                      >
                        {item?.order_type}
                      </TableCell>
                      <TableCell
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                        }}
                      >
                        {item?.company}
                      </TableCell>
                      <TableCell
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                        }}
                      >
                        {item?.state}
                      </TableCell>
                      <TableCell
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                        }}
                      >
                        {formatDate(item?.filing_date)}
                      </TableCell>

                      <TableCell
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                          color: item?.is_buffer ? "red" : "#000",
                        }}
                      >
                        {item?.due_date === "N/A"
                          ? item?.due_date
                          : formatDate(item?.due_date)}
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </CustomTable>
          ) : (
            <ComplianceCalender data={complianceData} />
          )}

          {!tabValue && Math.ceil(totalRecords / limit) > 1 && (
            <Box sx={{ display: "flex", justifyContent: "end", mt: 3, mb: 3 }}>
              <CommonPagination
                currentPage={pageNo}
                totalPages={Math.ceil(totalRecords / limit)}
                onPageChange={handlePageChange}
              />
            </Box>
          )}
        </ComplianceWrapper>
      )}
      {/* --------------------------------- Home Table Section ----------------------------------------*/}

      {/* <Box
        sx={{
          width: "100%",
          background: "white",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            color: "#01060B",
            fontSize: 20,
            fontWeight: 600,
            p: 2,
          }}
        >
          Bank and Payment Provider
        </Typography>

        <CustomTable headings={["Name", "", "Action", "Status"]}>
          {rows?.map((item, index) => (
            <TableRow>
              <TableCell
                colSpan={2}
                sx={{
                  width: "70%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <div>
                    <img src={item.img} alt="" />
                  </div>
                  <Typography>{item.title}</Typography>
                </Box>
              </TableCell>

              <TableCell>
                <Button
                  variant="contained"
                  sx={{
                    width: 113,
                    height: 33,
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  {item.button1}
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="text"
                  sx={{
                    background:
                      item.button2 == "Submitted"
                        ? "#EAF1FA"
                        : item.button2 == "Completed"
                        ? "#D9FFD2"
                        : "#FFF5DB",
                    width: 113,
                    height: 33,
                    fontSize: "12px",
                    fontWeight: 600,
                    color:
                      item.button2 == "Submitted"
                        ? "#2977CC"
                        : item.button2 == "Completed"
                        ? "#3DC826"
                        : "#E7AB12",
                  }}
                >
                  {item.button2}
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </CustomTable>
      </Box> */}
    </Box>
  );
};

export default Home;
